import { Base } from "ui/Scripts/source/framework/base";
import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IRecordEditItemTransferredProperty extends IEditItem {
    type: string;
    code: string;
    description: string;
    transferDate: number;
    returnDate: number;
    modifyUser: IModifyUser;

    getTitle(): string;
    getUiTitle(): string;
}

export class RecordEditItemTransferredProperty extends EditItem implements IRecordEditItemTransferredProperty {
    type: string;
    code: string;
    description: string;
    transferDate: number;
    returnDate: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IRecordEditItemTransferredProperty);
    constructor(obj?: any) {
        super(obj);
        this.type = obj && obj.type || "";
        this.code = obj && obj.code || "";
        this.description = obj && obj.description || "";
        this.transferDate = obj && obj.transferDate || 0;
        this.returnDate = obj && obj.returnDate || null;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }

    getUiTitle(): string {
        return this.code;
    }

    getTitle(): string {
        return this.code + ", " + Base.utcTimeToDateStr(this.transferDate);
    }

    static createNewRecordEditItemTransferredProperty = (): RecordEditItemTransferredProperty => {
        const result = new RecordEditItemTransferredProperty();
        result.id = Base.getGuid();
        result.transferDate = Base.getNowUtcDate().getTime();
        return result;
    };
        
    static sortRecordEditItemTransferredProperties(items: IRecordEditItemTransferredProperty[], column: string, asc: boolean): IRecordEditItemTransferredProperty[] {
        if (!items && items.length < 2) return items;
        if (column === "transferDate") {
            return items.sort((a: IRecordEditItemTransferredProperty, b: IRecordEditItemTransferredProperty) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.transferDate, b.transferDate)); });
        } else if (column === "returnDate") {
            return items.sort((a: IRecordEditItemTransferredProperty, b: IRecordEditItemTransferredProperty) => {
                const result = (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.returnDate, b.returnDate));
                if (result !== 0) return result;
                return (asc ? 1 : -1) * Base.numCompare(a.transferDate, b.transferDate);
            });
        } else if (column === "type") {
            return items.sort((a: IRecordEditItemTransferredProperty, b: IRecordEditItemTransferredProperty) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.type, b.type)); });
        } else if (column === "description") {
            return items.sort((a: IRecordEditItemTransferredProperty, b: IRecordEditItemTransferredProperty) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.description, b.description)); });
        } else {
            return items.sort((a: IRecordEditItemTransferredProperty, b: IRecordEditItemTransferredProperty) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
    }
}

export class RecordEditItemTransferredPropertySave extends EditItem {
    type: string;
    code: string;
    description: string;
    transferDate: number;
    returnDate: number;

    constructor();
    constructor(obj: IRecordEditItemTransferredProperty);
    constructor(obj?: any) {
        super(obj);
        this.type = obj && obj.type || "";
        this.code = obj && obj.code || "";
        this.description = obj && obj.description || "";
        this.transferDate = obj && obj.transferDate || 0;
        this.returnDate = obj && obj.returnDate || null;
    }
}
